import API from 'api';
import { PluginsResponse, StandardThunkAction } from 'types';
import { Action, actionCreator } from 'util/actions';

export const LOAD_PLUGINS_REQUEST = Symbol('loaders/LOAD_PLUGINS_REQUEST');
export const LOAD_PLUGINS_SUCCESS = Symbol('loaders/LOAD_PLUGINS_SUCCESS');
export const LOAD_PLUGINS_ERROR = Symbol('loaders/LOAD_PLUGINS_ERROR');

export type LoadPluginsRequestAction = Action<
  typeof LOAD_PLUGINS_REQUEST,
  null
>;
export type LoadPluginsSuccessAction = Action<
  typeof LOAD_PLUGINS_SUCCESS,
  PluginsResponse
>;
export type LoadPluginsErrorAction = Action<typeof LOAD_PLUGINS_ERROR, Error>;

const loadPluginsRequest = actionCreator<LoadPluginsRequestAction>(
  LOAD_PLUGINS_REQUEST,
);
const loadPluginsSuccess = actionCreator<LoadPluginsSuccessAction>(
  LOAD_PLUGINS_SUCCESS,
);
const loadPluginsError = actionCreator<LoadPluginsErrorAction>(
  LOAD_PLUGINS_ERROR,
);

export const loadPlugins = (): StandardThunkAction => {
  return async (dispatch, getState) => {
    try {
      dispatch(loadPluginsRequest());

      const plugins = await API.client.rest.get<PluginsResponse>(
        'plugins/public',
      );

      dispatch(loadPluginsSuccess(plugins));
    } catch (err) {
      dispatch(loadPluginsError(err));
    }
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/modules/loaders/load-plugins.ts